import { render, staticRenderFns } from "./OptionFreeFormat.vue?vue&type=template&id=6de39479&"
import script from "./OptionFreeFormat.vue?vue&type=script&lang=js&"
export * from "./OptionFreeFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports